import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import PetrovichRoute from './components/PetrovichRoute';
import HomePage from './pages/HomePage';
import CatalogPage from './pages/CatalogPage';
import ProductPage from './pages/ProductPage';
import WebinarsPage from './pages/WebinarsPage';
import CoursePage from './pages/CoursePage';
import LessonPage from './pages/LessonPage';
import { NewsPage, NewsPostPage } from './pages/NewsPages';
import CabinetPage from './pages/CabinetPage';
import PaymentResultPage from './pages/PaymentResultPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import SegPage from './pages/SegPage';
import CephToolPage from './pages/tools/CephToolPage';
import SuperimposeToolPage from './pages/tools/SuperimposeToolPage';
import { FullSegmentationPage } from './pages/tools/InstrumentPage';
import ContactPage from './pages/ContactPage';
import ContactsPage from './pages/ContactsPage';
import SubscriptionPage from './pages/SubscriptionPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import CephalometricPage from './pages/CephalometricPage';
import AdminPage from './pages/AdminPage';
import JawStlViewer from './pages/jaw_stl_viewer';

import ThemeToggle from './components/ThemeToggle';
import { LangSync } from './lib/lang';
import { Toaster } from 'sonner';
import './App.css';

// Initialize i18n
import './i18n';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <LangSync />
          <ThemeToggle />
          <Routes>
            {/* Публичные маршруты платформы: русская версия и версия с префиксом /en */}
            {['', '/en'].map((p) => (
              <React.Fragment key={p || 'ru'}>
                <Route path={p || '/'} element={<HomePage />} />
                <Route path={`${p}/catalog`} element={<CatalogPage />} />
                <Route path={`${p}/products/:slug`} element={<ProductPage />} />
                <Route path={`${p}/webinars`} element={<WebinarsPage />} />
                <Route path={`${p}/webinars/:slug`} element={<CoursePage />} />
                <Route path={`${p}/webinars/:slug/lessons/:lessonId`} element={<LessonPage />} />
                <Route path={`${p}/news`} element={<NewsPage />} />
                <Route path={`${p}/news/:slug`} element={<NewsPostPage />} />
                <Route path={`${p}/payment/result`} element={<ProtectedRoute><PaymentResultPage /></ProtectedRoute>} />
                <Route path={`${p}/cabinet/*`} element={<CabinetPage />} />
                <Route path={`${p}/tools/ceph`} element={<ProtectedRoute><CephToolPage /></ProtectedRoute>} />
                <Route path={`${p}/tools/superimpose`} element={<ProtectedRoute><SuperimposeToolPage /></ProtectedRoute>} />
                <Route path={`${p}/tools/segment-full`} element={<AdminRoute><FullSegmentationPage /></AdminRoute>} />
                <Route path={`${p}/tools/cbct-report`} element={<Navigate to={`${p}/tools/segment-full`} replace />} />
              </React.Fragment>
            ))}
            <Route path="/login/*" element={<LoginPage />} />
            <Route path="/register/*" element={<RegisterPage />} />
            <Route path="/contact/*" element={<ContactsPage />} />
            <Route path="/contacts/*" element={<ContactPage />} />            
            <Route path="/privacy-policy/*" element={<PrivacyPolicyPage />} />
            <Route path="jaws" element={<JawStlViewer />} />

            
            {/* Защищенные маршруты */}
            
            <Route 
              path="/metrica/*" 
              element={
                <PetrovichRoute>
                  <CephalometricPage />
                </PetrovichRoute>
              } 
            />
            <Route 
              path="/en/metrica/*" 
              element={
                <PetrovichRoute>
                  <CephalometricPage />
                </PetrovichRoute>
              } 
            />
            <Route 
              path="/pt/metrica/*" 
              element={
                <PetrovichRoute>
                  <CephalometricPage />
                </PetrovichRoute>
              } 
            />

            <Route 
              path="/profile/*" 
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/klkt-segment/*" 
              element={
                <ProtectedRoute>
                  <SegPage />
                </ProtectedRoute>
              } 
            />
            <Route
              path="/admin/*"
              element={
                <AdminRoute>
                  <AdminPage />
                </AdminRoute>
              }
            />
            <Route path="/subscription/*" element={<SubscriptionPage /> }/>
            
            {/* Резервный маршрут для несуществующих страниц */}
            <Route path="/en/*" element={<Navigate to="/en" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;